import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Language, Product, UomElement } from 'types/schema';
import utilsMessages from 'utils/messages';

const useProductUomInfo = (product: Product) => {
  const { uom, netUom, baseUom, baseUnit, netUnit } = product;
  const lang = localStorage.getItem('lang') || Language.Vi;
  const baseUoms = JSON.parse(localStorage.getItem('baseUoms') || '{}');
  const netUoms = JSON.parse(localStorage.getItem('netUoms') || '{}');
  const uoms = JSON.parse(localStorage.getItem('uoms') || '{}');
  const langName = lang === Language.Vi ? 'nameVn' : 'nameEn';

  const SPECIAL_UOM = ['Kg', 'L/Lít/Liter'];

  const currUom: string = uom ? uoms?.[uom]?.[langName] : '';
  const currNetUom: string = netUom ? netUoms?.[netUom]?.[langName] : '';
  const currBaseUom: string = useMemo(() => {
    if (!baseUom || !baseUoms) return '';
    const arrBaseUoms = Object.values(baseUoms);
    const result = arrBaseUoms.find((item: UomElement) => item[langName] === baseUom);
    return result?.[langName] || '';
  }, [baseUom, baseUoms, langName]);

  const isSpecialUom = useMemo(() => {
    if (currNetUom === SPECIAL_UOM[0] && currUom === SPECIAL_UOM[0]) return true;

    if (SPECIAL_UOM.length > 1 && SPECIAL_UOM[1].includes('L') && currNetUom?.includes('L')) {
      if (lang === Language.Vi && currUom?.includes('Lít')) return true;
      if (lang === Language.En && currUom?.includes('Liter')) return true;
    }

    return false;
  }, [currNetUom, currUom, lang, SPECIAL_UOM]);

  const uomInfo = useMemo(() => {
    if (!currUom) return '';

    const isSameBaseUom = currBaseUom.toLowerCase() === currUom.toLowerCase();
    // const isSameNetUom = currNetUom === currUom;

    if (baseUnit && currBaseUom && netUnit && currNetUom) {
      if (isSameBaseUom && baseUnit === 1) {
        return isSpecialUom ? renderUomLabel(currUom) : `${netUnit}${currNetUom.toLowerCase()}/${currUom}`;
      }
      return `${netUnit}${currNetUom.toLowerCase()}${' x '}${baseUnit} ${currBaseUom}${isSameBaseUom ? '' : `/${currUom}`}`;
    }
    if (baseUnit && currBaseUom) {
      return `${baseUnit} ${currBaseUom}${!isSameBaseUom ? `/${currUom}` : ''}`;
    }
    if (netUnit && currNetUom) {
      if (isSpecialUom && netUnit === 1) return renderUomLabel(currUom);
      return `${netUnit}${currNetUom.toLowerCase()}${!isSpecialUom ? `/${currUom}` : ''}`;
    }
    return renderUomLabel(currUom);
  }, [baseUnit, currBaseUom, netUnit, currNetUom, currUom]);

  return {
    uomInfo: uomInfo,
    uom: currUom,
    baseUom: currBaseUom,
    netUom: currNetUom,
  };
};

function renderUomLabel(uom: string) {
  return (
    <>
      <FormattedMessage {...utilsMessages.dvt} />: {uom}
    </>
  );
}

export default useProductUomInfo;
